(function () {
  function initEtualiCarousel(root) {
    if (!root || root.dataset.vpCarouselInit === '1') return;

    const track = root.querySelector('[data-vp-track]');
    const prevBtn = root.querySelector('[data-vp-prev]');
    const nextBtn = root.querySelector('[data-vp-next]');
    const dotsWrap = root.querySelector('[data-vp-dots]');

    if (!track || !prevBtn || !nextBtn || !dotsWrap) return;

    root.dataset.vpCarouselInit = '1';

    let cards = [];
    let visibleCount = 3;
    let maxIndex = 0;
    let currentIndex = 0;
    let step = 0;
    let timer = null;
    let resizeTimer = null;
    let scrollTimer = null;
    let isHovered = false;

    function getVisibleCount() {
      if (window.innerWidth <= 767) return 1;
      if (window.innerWidth <= 1024) return 2;
      return 3;
    }

    function getGap() {
      const styles = getComputedStyle(track);
      return parseFloat(styles.columnGap || styles.gap || '16') || 16;
    }

    function measureStep() {
      if (!cards.length) return 0;
      if (cards.length > 1) {
        return cards[1].offsetLeft - cards[0].offsetLeft;
      }
      return cards[0].getBoundingClientRect().width + getGap();
    }

    function clamp(n, min, max) {
      return Math.max(min, Math.min(n, max));
    }

    function stopTimer() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    function startTimer() {
      stopTimer();
      if (isHovered || maxIndex <= 0) return;

      timer = setInterval(() => {
        goNext();
      }, 3000);
    }

    function resetTimer() {
      stopTimer();
      startTimer();
    }

    function updateDots() {
      const dots = dotsWrap.querySelectorAll('.vp-dot');
      dots.forEach((dot, i) => {
        const active = i === currentIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    function buildDots() {
      dotsWrap.innerHTML = '';
      const dotCount = maxIndex + 1;

      for (let i = 0; i < dotCount; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'vp-dot';
        dot.setAttribute('aria-label', 'Ir a la posición ' + (i + 1));
        dot.addEventListener('click', () => {
          goTo(i, true);
          resetTimer();
        });
        dotsWrap.appendChild(dot);
      }

      updateDots();
    }

    function goTo(index, smooth) {
      if (!cards.length) return;

      currentIndex = clamp(index, 0, maxIndex);
      step = measureStep();

      const left = currentIndex * step;

      track.scrollTo({
        left,
        behavior: smooth ? 'smooth' : 'auto'
      });

      updateDots();
    }

    function goNext() {
      if (maxIndex <= 0) return;

      if (currentIndex >= maxIndex) {
        goTo(0, true);
        return;
      }

      goTo(currentIndex + 1, true);
    }

    function goPrev() {
      if (maxIndex <= 0) return;

      if (currentIndex <= 0) {
        goTo(maxIndex, true);
        return;
      }

      goTo(currentIndex - 1, true);
    }

    function syncFromScroll() {
      if (!cards.length || step <= 0) return;

      const idx = clamp(Math.round(track.scrollLeft / step), 0, maxIndex);
      if (idx !== currentIndex) {
        currentIndex = idx;
        updateDots();
      }
    }

    function setup() {
      stopTimer();

      cards = Array.from(track.querySelectorAll('.vp-card'));
      visibleCount = getVisibleCount();
      maxIndex = Math.max(0, cards.length - visibleCount);
      step = measureStep();

      prevBtn.disabled = maxIndex <= 0;
      nextBtn.disabled = maxIndex <= 0;

      buildDots();
      goTo(0, false);
      startTimer();
    }

    prevBtn.addEventListener('click', () => {
      goPrev();
      resetTimer();
    });

    nextBtn.addEventListener('click', () => {
      goNext();
      resetTimer();
    });

    track.addEventListener('mouseenter', () => {
      isHovered = true;
      stopTimer();
    });

    track.addEventListener('mouseleave', () => {
      isHovered = false;
      startTimer();
    });

    track.addEventListener('scroll', () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(syncFromScroll, 80);
    }, { passive: true });

    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(setup, 150);
    });

    setup();
  }

  function boot() {
    document.querySelectorAll('#vp-etuali-includes').forEach(initEtualiCarousel);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);

  document.addEventListener('shopify:section:unload', function (event) {
    const root = event.target && event.target.querySelector && event.target.querySelector('#vp-etuali-includes');
    if (root) root.dataset.vpCarouselInit = '';
  });
})();